import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(dashboard)/pricing/components/PricingInteractive.tsx");
